if (process.env.NODE_ENV !== 'development') {
  /* globals __webpack_public_path__ */
  __webpack_public_path__ = `${window.STATIC_URL}assets/js-es6/dist/`;
}

import Root from './root';
import render from 'utils/renderToDOM';

render(Root, 'product');



// WEBPACK FOOTER //
// ./src/product/entry.js